import { render, staticRenderFns } from "./ArchiveVariants.vue?vue&type=template&id=60b7a9ec&scoped=true"
import script from "./ArchiveVariants.vue?vue&type=script&lang=js"
export * from "./ArchiveVariants.vue?vue&type=script&lang=js"
import style0 from "./ArchiveVariants.vue?vue&type=style&index=0&id=60b7a9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b7a9ec",
  null
  
)

export default component.exports